export const GET_CIATATION_PDF_STATES="pay-citation/GET_CIATATION_PDF_STATES";
export const SET_CIATATION_PDF_STATES = "pay-citation/SET_CIATATION_PDF_STATES";
export const GET_CIATATION_PDF_STATES_UNPAID="pay-citation/GET_CIATATION_PDF_STATES_UNPAID";

export const getDriverCitationPDFStates=(data)=>{
    return{
        type:GET_CIATATION_PDF_STATES,
        payload:data
    }
}

export const getDriverCitationPDFStatesUnpaid=(data)=>{
    return{
        type:GET_CIATATION_PDF_STATES_UNPAID,
        payload:data
    }
}

export const setDriverCitationPDFStates=(data)=>{
    return{
        type:SET_CIATATION_PDF_STATES,
        payload:data
    }
}